import Vue from "vue";
import store from "~/store";
import VueI18n from "vue-i18n";
import axios from "axios";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: "us",
    silentTranslationWarn: true,
    messages: {}
});

/**
 * @param {String} locale
 */
export async function loadMessages(locale) {
    if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    //     const messages = await import(
    //   /* webpackChunkName: '' */ `~/lang/${locale}`
    //     );
        try {
            const { data } = await axios.get(`${locale}.json`,{
                baseURL: process.env.VUE_APP_LANGS_BUCKET
                // baseURL: "https://leadgrease-locales.s3.eu-west-1.amazonaws.com"
            });
            i18n.setLocaleMessage(locale, data);
        } catch (error) {
            console.error("Error loading messages", error);
            const messages = await import(`~/lang/${locale}`);
            i18n.setLocaleMessage(locale, messages);
        }
        
    }

    /* if (i18n.locale !== locale) {
        i18n.locale = locale;
    } */
}


(async function () {
    let storeLocales = store.getters["lang/locales"];
    let storeLocale = store.getters["lang/locale"];
    if (storeLocales.length > 0) {
        for (let i = 0; i < storeLocales.length; i++) {
            const locale = storeLocales[i];
            console.log(`Loading messages for locale ${locale}`);
            await loadMessages(locale);
        }
    }

    if (i18n.locale !== storeLocale) {
        i18n.locale = storeLocale;
    }

})();

export default i18n;
